import { apiClient } from "../../../lib/axios";
import { LiveProgressResponse, ProjectsResponse } from "./types";

export const liveProgressApi = {
  fetchLiveProgress: async (): Promise<LiveProgressResponse> => {
    const response = await apiClient.get("/live-progress");
    return response.data;
  },
  fetchProjects: async (params?: {
    page?: number;
    limit?: number;
  }): Promise<ProjectsResponse> => {
    const response = await apiClient.get("/projects", { params });
    return response.data;
  },
};

